import baseApi from "./baseApi"

export default {
    async uploadLocalData(localDB) {
        const data = new FormData();
        data.set("localdb", localDB);
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/localData/upload", data, {
            headers: {
                "Content-Type": "multipart/form-data; boundary=" + data._boundary
            }
        });
        return result.data;
    },
}